import React, { useEffect, useState } from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import './App.css';
import  './Resources/Actions.css';


export default function Createuser(){
    const navigate = useNavigate();
    const [user,setUser] = useState([]);
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    var userid = user.length > 0 ? user.length+1 : 1;

    console.log(userid);
    useEffect(()=>{
        
        fetch(API_URL+"api/User/GetUser")
        .then(response => response.json())
        .then(data =>{setUser(data)})},[])

    function makeuser()
    {
        
        var username = document.getElementById('username').value.trim();
        var password = document.getElementById('password').value;
        var usertype = document.getElementById('usertype').value;

        var data = new FormData();
        data.append("userid",userid);
        data.append("username",username);
        data.append("password",password);
        data.append("usertype",usertype);

        var check =  user.filter(e =>{if(username.trim() === e.UserName) return e});

        console.log(check);
        console.log(username);
        console.log(usertype);

        if(check.length > 0 && check[0].UserName === username)
        {
            alert("Please Change the User Name");
        }
        else
        {
                fetch(API_URL+"api/User/CreateUser",{method:"POST", body:data})
                .then(response => response.json())
                .then(()=>{});

                fetch(API_URL+"api/User/IncrementUserID?id=" + userid,{method:"PUT",body:null})
                .then(res=>res.json())
                .then(()=>{})

                showOKdialog();
        }

    } 

    function showOKdialog()
    {
        const dialog = document.getElementById('myDialog');
         dialog.showModal();
    }


    return(
        <>
        <div className="reportheader"> 
            Create User
            <Navbar/>
        </div> 
        
        
        <div>
            <label for = "userid" style ={{marginLeft:"50px",marginTop:"20px"}}>User ID</label>
            <input id = "userid" value = {userid} style={{marginLeft:"8px",height: "30px",marginTop:"20px",width:"200px"}}></input><br/><br/>
            <label for = "username" style ={{marginLeft:"22px"}}>User Name</label>
            <input id = "username" style ={{marginLeft:"10px",height: "30px",width:"200px"}}></input><br/><br/>
            <label for = "password" style ={{marginLeft:"35px"}}>Password</label>
            <input id = "password" style ={{marginLeft:"10px",height: "30px",width:"200px"}}></input><br/><br/>
            <label for = "usertype" style ={{marginLeft:"35px"}}>UserType</label>
            <select id = "usertype" name='gender' style ={{marginLeft:"10px",height: "30px",width:"210px"}}>
        <option value = "1">Admin</option>
        <option value = "2" >User</option>
      </select> <br /><br/>
        </div>
        
        <div style ={{marginTop:"70px"}}>
        <button type = "button"  className="actionbuttons" onClick={()=>{makeuser();}}>Create</button> 
        <button type = "button"  className="actionbuttons" style ={{backgroundColor:"red"}} onClick={()=>{navigate('/user')}}>Cancel</button>
        </div>

        <dialog id="myDialog" className="okdialog"> <p> User Creation Successful For ID :   {userid} </p>
            <button className="okdialogbutton" onClick={()=>{navigate('/home')}}>OK</button>
        </dialog>
        </>

    )
}

